// extracted by mini-css-extract-plugin
export default {"ImportSparkle":"_ImportSparkle--HBc2G","SparkleIcon":"_SparkleIcon--OJ7fw"};